/*
 * Copyright (c) 2024 by Guangdong Sun Railway Information Technology, Inc. 
 * All Rights Reserved.
 *  
 * @Author: Dlx
 * @Date: 2024-08-26 14:58:05
 * 
 * @LastEditors: Dlx
 * @LastEditTime: 2024-09-20 15:55:41
 * 
 * @Description: 
 * 
 */
// import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

createRoot(document.getElementById('root')!).render(
  // <StrictMode>
    <App />
  // </StrictMode>
)
